/**
 * Badge — маленькая плашка-пилюля статуса. tone задаёт цвет, size — размер.
 * Если передан onClick — рендерится кликабельной кнопкой.
 */
import type { ReactNode } from "react";

type Tone = "ok" | "warn" | "err" | "muted";
type Size = "sm" | "md";

const TONES: Record<Tone, string> = {
  ok: "bg-emerald-400/15 text-emerald-300",
  warn: "bg-amber-400/15 text-amber-300",
  err: "bg-red-500/15 text-red-300",
  muted: "bg-white/10 text-white/50",
};

const SIZES: Record<Size, string> = {
  sm: "px-2 py-0.5 text-[11px]",
  md: "px-2.5 py-1 text-[12px]",
};

export function Badge({
  tone = "muted",
  size = "md",
  children,
  onClick,
  className = "",
}: {
  tone?: Tone;
  size?: Size;
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  const cls = `rounded-full font-medium ${TONES[tone]} ${SIZES[size]} ${className}`;
  return onClick ? (
    <button onClick={onClick} className={`${cls} active:opacity-70`}>
      {children}
    </button>
  ) : (
    <span className={cls}>{children}</span>
  );
}
